import React, { useEffect, useState } from 'react';
import { OrderEmails } from '../AdminClasses';
import { Button, Header, Icon, Message, Table, Modal, useFrontier } from 'react-frontier2';
import { fromUnixLocal } from '@arema/components/Util';
import API from '../API';

interface OrderMailsModalProps {
	order_id: number,
	order_hash?: string,
	open: boolean,
	onClose: ()=>void,
}

function OrderEmailsModal(props: OrderMailsModalProps){
	var { Toast } = useFrontier();
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [mails, setMails] = useState<OrderEmails[]>(null);
	var [loadingSend, setLoadingSend] = useState<boolean>(false);
	let order_id = props.order_id || null;

	useEffect(()=>{
		if(props.open && !Number.isNaN(order_id)){
			loadData(order_id);
		}
	}, [props.open]);

	var loadData = async (order_id: number)=>{
		API.getOrderEmails(order_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setMails(res.data);
		}).catch(err=>{
			setModalPrompts(['Hubo un error cargando los correos (LCL-1)']);
		})
	}

	var resendEmail = (email_id: number)=>{
		setLoadingSend(true);
		API.resendOrderEmail(order_id, email_id).then(res=>{
			if(res.error){ 
				return Toast.error(res.message);
			}else{
				return Toast.success('Se reenvio el correo correctamente');
			}
		}).catch(err=>{
			Toast.error('Hubo un error enviando los correos (LCL-1)');
		}).finally(()=>{
			setLoadingSend(false);
		})
	}

	return <Modal open={props.open} onClose={props.onClose}>
		<Modal.Header>Correos {props.order_hash}</Modal.Header>
		{!!props.open && <Modal.Content>
			{mails === null ? (
				<Header loading text='Cargando correos' />
			) : (
				mails ? (
					<Table fitted>
						<Table.Head data={[['ID', 'Tipo', 'Correo', 'Fecha', 'Estatus', <Icon name='ellipsis-h' />]]} />
						<Table.Body>
							{mails && mails.length==0 && (
								<Table.Cell empty row colSpan={100}>Esta orden no tiene correos</Table.Cell>
							)}
							{mails && mails.map((a, i)=>(
								<Table.Row 
									collapsingIndexes={[1, 3, 0, 4, 5]}
									centeredIndexes={[4, 5]}
									data={[
										a.email_id,
										a.type_name,
										a.email,
										fromUnixLocal(a.date_created).toFormat('DD/MM/YY HH:mm:ss'),
										<Icon name={a.delivered ? 'check' : 'minus'} style={{ color: a.delivered ? 'green' : 'grey' }} />,
										<Button color='black' loading={loadingSend} icon iconName="ellipsis-h" size="tiny" menu={[{
											text: 'Reenviar', iconName: 'envelope', onClick: ()=>resendEmail(a.email_id)
										}]} />
									]}
								/>
							))}
						</Table.Body>
					</Table>
				) : (
					<Message style={{ marginTop: 15 }} type='error' list={modalPrompts} />
				)
			)}
		</Modal.Content>}
		<Modal.Actions>
			<Button basic text='Cerrar' onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default OrderEmailsModal;